import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollProgress from './components/ScrollProgress';
import BackToTop from './components/BackToTop';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div data-testid="site-shell" className="App min-h-screen bg-background text-foreground antialiased overflow-x-hidden">
      <BrowserRouter>
        <ScrollToTop />
        <ScrollProgress />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projeler" element={<ProjectsPage />} />
          <Route path="/projeler/:slug" element={<ProjectDetailPage />} />
          <Route path="/urunler" element={<ProductsPage />} />
          <Route path="/urunler/:slug" element={<ProductDetailPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <BackToTop />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
